<!-- Modal LOGIN-->
<div class="modal fade contenedor-modal" id="modalLogin" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body p-0">
                <app-login-form [esModal]="true" (resultEvent)="validarYCerrar($event)"
                    (goRegister)="abrirModal('register')">
                </app-login-form>
            </div>
        </div>
    </div>
</div>

<!-- Modal REGISTRO-->
<div class="modal fade contenedor-modal" id="modalRegister" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body p-0">
                <app-register-form [esModal]="true" (resultEvent)="validarYCerrar($event)"
                    (goLogin)="abrirModal('login')">
                </app-register-form>
            </div>
        </div>
    </div>
</div>

<!-- Navbar -->
<div class="container-fluid cm-navbar pr-0">

    <!-- Superior - Búsqueda, suscribirse, login y registro -->
    <div class="row superior bg-white">
        <div class="col-12 pl-5">
            <div class="d-flex">

                <div class="buscador flex-gorw-1">
                    <i class="fa fa-search cm-tx-color-7" aria-hidden="true"></i>
                    <input type="text" class="buscador-input" #buscador placeholder="Buscar..."
                        (change)="buscar(buscador)" (keyup)="buscar(buscador)" (keydown.enter)="buscarYa(buscador)">
                </div>

                <div class="d-none d-lg-flex">
                    <!-- Google Play -->
                    <button class="btn cm-bg-color-0 px-4 text-white rounded-0 me-2 border-right"
                        (click)="descargarApp()">
                        <i class="fab fa-google-play mr-2"></i>
                        <span class="fs-6">

                            Descargar App
                        </span>
                    </button>

                    <!-- Login -->
                    <button class="btn cm-bg-color-0 px-4 text-white rounded-0" (click)="abrirModal('login')"
                        *ngIf="!isLogged">Entrar</button>

                    <!-- Registro -->
                    <button class="btn cm-bg-color-11 px-4 text-white rounded-0" (click)="abrirModal('register')"
                        *ngIf="!isLogged">Registrarme</button>

                    <!-- Suscripción -->
                    <button class="btn cm-bg-color-11 px-4 text-white rounded-0" routerLink="suscripcion"
                        *ngIf="(isLogged && !hasSuscription) || (isLogged && usuario?.suscription?.status != 1)">Suscribirme</button>

                    <!-- Suscripción -->
                    <button class="btn cm-bg-color-11 px-4 text-white rounded-0" routerLink="cuenta"
                        *ngIf="isLogged && hasSuscription && usuario?.suscription?.status == 1">
                        {{usuario?.suscription?.subscriptionPlan}}</button>
                </div>

            </div>
        </div>
    </div>

    <!-- Inferior - Logo y menú items-->
    <div class="row inferior">
        <div class="col-12 px-5 py-3 py-lg-0 d-flex justify-content-center justify-content-lg-between">

            <div class="d-flex">
                <a class="logo mr-5" routerLink="/home">
                    <img src="assets\img\logos_cinemateca\SVG\logo_completo_blanco.svg" alt="Cinemateca" />
                    <!-- <span class="beta">BETA</span> -->
                </a>

                <!-- Items -->
                <div class="menu d-none d-lg-flex">

                    <!-- Loading -->
                    <div *ngIf="menuItemsLoading" class="d-flex">
                        <div class="skeleton skeleton-line" style="--bg: var(--cm-white-15); --l-h:15px; --c-w: 200px">
                        </div>
                        <div class="skeleton skeleton-line" style="--bg: var(--cm-white-15); --l-h:15px; --c-w: 200px">
                        </div>
                        <div class="skeleton skeleton-line" style="--bg: var(--cm-white-15); --l-h:15px; --c-w: 200px">
                        </div>
                    </div>

                    <!-- MENU ITEMS DESKTOP -->
                    <ul class="items list-group list-group-horizontal " *ngIf="!menuItemsLoading && !isFelixOliver">
                        <div *ngFor="let item of menuItems">

                            <!-- Dropdowns -->
                            <li class="list-group-item dropdown-toggle" data-toggle="dropdown"
                                *ngIf="item.type == 'lista'">
                                <a>{{ item.name }}</a>

                                <!-- RouterLink -->
                                <div class="dropdown-menu" *ngIf="item.listType == 'routerLink'">
                                    <a class="dropdown-item" routerLink="{{ subItem.url }}"
                                        *ngFor="let subItem of item.list">{{ subItem.name }}</a>
                                </div>

                                <!-- Normal -->
                                <div class="dropdown-menu" *ngIf="item.listType == 'normal'">
                                    <a class="dropdown-item" href="{{ subItem.url }}"
                                        [target]="{'_blank':item.external}" *ngFor="let subItem of item.list">
                                        {{ subItem.name }}
                                    </a>
                                </div>
                            </li>

                            <!-- RouterLinks -->
                            <li class="list-group-item" *ngIf="item.type == 'routerLink'" routerLink="{{ item.path }}">
                                <a> {{ item.name }}</a>
                            </li>

                            <!-- Normales -->
                            <li class="list-group-item" *ngIf="item.type == 'normal'">
                                <a href="{{ item.path }}" [target]="{'_blank':item.external}">{{ item.name }}</a>
                            </li>
                        </div>
                    </ul>

                    <!-- MENU ITEMS DESKTOP FELIX OLIVER-->
                    <ul class="items list-group list-group-horizontal " *ngIf="!menuItemsLoading && isFelixOliver">
                        <div *ngFor="let item of menuItemsFo">

                            <!-- Dropdowns -->
                            <li class="list-group-item dropdown-toggle" data-toggle="dropdown"
                                *ngIf="item.type == 'lista'">
                                <a>{{ item.name }}</a>

                                <!-- RouterLink -->
                                <div class="dropdown-menu" *ngIf="item.listType == 'routerLink'">
                                    <a class="dropdown-item" routerLink="{{ subItem.url }}"
                                        *ngFor="let subItem of item.list">{{
                                        subItem.name }}</a>
                                </div>

                                <!-- Normal -->
                                <div class="dropdown-menu" *ngIf="item.listType == 'normal'">
                                    <a class="dropdown-item" href="{{ subItem.url }}"
                                        [target]="{'_blank':item.external}" *ngFor="let subItem of item.list">
                                        {{ subItem.name }}
                                    </a>
                                </div>
                            </li>

                            <!-- RouterLinks -->
                            <li class="list-group-item" *ngIf="item.type == 'routerLink'" routerLink="{{ item.path }}">
                                <a> {{ item.name }}</a>
                            </li>

                            <!-- Normales -->
                            <li class="list-group-item" *ngIf="item.type == 'normal'">
                                <a href="{{ item.path }}" [target]="{'_blank':item.external}">{{ item.name }}</a>
                            </li>
                        </div>
                    </ul>

                </div>
            </div>

            <!-- Usuario -->
            <div class="user d-none d-lg-flex align-items-center">
                <div class="btn btn-secondary cm-bg-white-15 border-0  dropdown-toggle" data-toggle="dropdown"
                    *ngIf="usuario">
                    <span class="text-white"> {{ usuario.firstName }} {{ usuario.lastName }} </span>

                    <!-- RouterLink -->
                    <div class="dropdown-menu dropdown-menu-dark text-right">
                        <span class="dropdown-item disabled">{{ usuario.firstName }} {{ usuario.lastName }}</span>
                        <div class="dropdown-divider"></div>

                        <a class="dropdown-item" routerLink="./mi-perfil"> Perfil</a>
                        <a class="dropdown-item" routerLink="./cuenta"> Cuenta</a>
                        <a class="dropdown-item" (click)="cerrarSesion()"> Cerrar sesión</a>
                    </div>
                </div>
            </div>

            <!-- BOTON MENU -->
            <div class="btnSidebar d-lg-none pr-5">
                <button class="hamburger hamburger--collapse white" type="button"
                    [ngClass]="{ 'is-active': menuLateral }" (click)="menu_alternar()">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>

                <!-- <div class="hamburger hamburger--collapse white" [ngClass]="{ 'is-active': menuLateral }">
                    <div class="hamburger-box">
                        <div class="hamburger-inner"></div>
                    </div>
                </div> -->
            </div>

        </div>
    </div>

</div>

<!-- Manu inferior mobile -->
<app-menu-sidebar [menuItems]="menuItems" *ngIf="!isFelixOliver"></app-menu-sidebar>
<app-menu-sidebar [menuItems]="menuItemsFo" *ngIf="isFelixOliver"></app-menu-sidebar>